import { actionTypesEnum } from '../enum';

export default (state = null, action) => {

  if(action.type === actionTypesEnum.getToken){
    return action.payload;
  }
  
   return state;
}